import axios from "axios";
import { url } from "./baseUrl.js";

const axiosStudentInstance = axios.create({
  baseURL: `${url}/api`,
  withCredentials: true,
});

export default axiosStudentInstance;
